import { api } from "@/lib/api";

const KEY = "fhp-pending-drops";
const STUCK = "fhp-stuck-drops";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* storage full */ } };

export const pendingCount = () => read().length;
export const stuckCount = () => { try { return (JSON.parse(localStorage.getItem(STUCK)) || []).length; } catch { return 0; } };
const retryLater = (s) => s === 401 || s === 403 || s === 408 || s === 429 || s >= 500;

export function queueDrop(body) {
  write([...read(), { ...body, queuedAt: new Date().toISOString() }].slice(-50));
  window.dispatchEvent(new Event("pending-drops"));
}

let flushing = false;
export async function flushDrops() {
  if (flushing || !read().length) return;
  flushing = true;
  try {
    for (const item of read()) {
      const { queuedAt, ...body } = item;
      try { await api.addDrop(body); }
      catch (e) {
        if (!e.response || retryLater(e.response.status)) break; // keep and try again later
        // Server refused this one for good: keep a copy on the phone instead of losing it.
        try { localStorage.setItem(STUCK, JSON.stringify([...JSON.parse(localStorage.getItem(STUCK) || "[]"), item].slice(-50))); } catch { /* storage full */ }
      }
      write(read().filter((x) => x.queuedAt !== queuedAt));
    }
  } finally {
    flushing = false;
    window.dispatchEvent(new Event("pending-drops"));
    window.dispatchEvent(new Event("drops-changed"));
    window.dispatchEvent(new Event("sites-changed"));
  }
}
